const SentSms = () =>
  import(/* webpackChunkName: "message-sent-sms" */ '@/pages/message/sent/sms/index.vue')

export default {
  path: 'sms',
  meta: {
    label: 'sms',
    auth: 'sms'
  },
  component: {
    name: 'Sms',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageSentSms',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SentSms
    }
  ]
}
